@if (
  {
    violations: violations$ | async,
    isSubmitting: isSubmitting(),
    partners: partners(),
    selectedPartner: selectedPartner(),
    establishments: establishmentsListener?.data$ | async,
    establishmentsLoadingError: establishmentsListener?.errorLoading$,
    salePoints: salePointsListener?.data$ | async,
    salePointsLoadingError: salePointsListener?.errorLoading$,
    countries: countriesListener?.data$ | async,
    countriesLoadingError: countriesListener?.errorLoading$,
    cities: citiesListener?.data$ | async,
    citiesLoadingError: citiesListener?.errorLoading$,
    districts: districtsListener?.data$ | async,
    districtsLoadingError: districtsListener?.errorLoading$
  };
  as STATE
) {
  <main>
    <custom-modal-card>
      <ng-container header>
        <ng-container header>
          <default-modal-header
            [title]="modalTitle"
            [description]="modalDescription"
          ></default-modal-header>
        </ng-container>
      </ng-container>

      <ng-container body>
        <section>
          <form [formGroup]="form" class="form-container">
            <section class="form-container__group">
              <hgroup>Information de la facture</hgroup>
              <article class="form-grid--rows">
                <div>
                  <label for="type" requiredAsterisk="type" class="form__label"
                    >Type de Facture (Hors avoir sur facture)</label
                  >
                  <ng-select
                    [items]="$any(invoiceTypes)"
                    labelForId="type"
                    appendTo="body"
                    formControlName="type"
                    clearAllText="Effacer"
                    placeholder="Sélectionner le type de facture"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      {{ item | invoiceTypeLabel }}
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item">
                      {{ item | invoiceTypeLabel }}
                    </ng-template>
                  </ng-select>
                </div>
              </article>
              <article class="form-grid--cols">
                <div>
                  <label
                    for="billingType"
                    requiredAsterisk="billingType"
                    class="form__label"
                    >Type de client</label
                  >
                  <ng-select
                    [items]="$any(billingTypes)"
                    bindLabel="label"
                    bindValue="value"
                    labelForId="billingType"
                    appendTo="body"
                    formControlName="billingType"
                    clearAllText="Effacer"
                    [clearable]="false"
                    placeholder="Sélectionner le type de facturation"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      {{ item | billingTypeLabel }}
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item">
                      {{ item | billingTypeLabel }}
                    </ng-template>
                  </ng-select>
                </div>
                <div>
                  <label
                    for="paymentMethods"
                    requiredAsterisk="paymentMethods"
                    class="form__label"
                    >Mode de paiement</label
                  >
                  <ng-select
                    [items]="$any(paymentMethods)"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    labelForId="paymentMethods"
                    appendTo="body"
                    formControlName="paymentMethods"
                    clearAllText="Effacer"
                    placeholder="Sélectionner le mode de paiement"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      {{ item | invoicePaymentMethod }}
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item">
                      {{ item | invoicePaymentMethod }}
                    </ng-template>
                  </ng-select>
                </div>
                <div>
                  <label
                    for="establishment"
                    class="form__label"
                    requiredAsterisk="establishmentId"
                    >Etablissement</label
                  >
                  @if (STATE.establishments) {
                    <ng-select
                      [items]="STATE.establishments"
                      [closeOnSelect]="true"
                      [clearable]="true"
                      [searchable]="true"
                      id="establishment"
                      formControlName="establishmentId"
                      bindLabel="name"
                      bindValue="id"
                      clearAllText="Effacer"
                      placeholder="Sélectionner un établissement"
                      (clear)="salesPointIdControl?.reset()"
                    >
                    </ng-select>
                    <form-error
                      [control]="form.get('establishmentId')"
                    ></form-error>
                  } @else {
                    <loading-or-error
                      (retry)="initEstablishmentsListener()"
                      [error$]="STATE.establishmentsLoadingError"
                      spinnerSize="sm"
                    ></loading-or-error>
                  }
                </div>
                <div>
                  <label
                    for="salePoint"
                    class="form__label"
                    requiredAsterisk="salesPointId"
                    >Point de vente</label
                  >
                  @if (STATE.salePoints) {
                    <ng-select
                      [items]="STATE.salePoints"
                      [closeOnSelect]="true"
                      [clearable]="true"
                      [searchable]="true"
                      id="salePoint"
                      formControlName="salesPointId"
                      bindLabel="name"
                      bindValue="id"
                      clearAllText="Effacer"
                      placeholder="Sélectionner le point de vente"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        <div class="flex flex-col">
                          <span class="font-medium">{{ item.name }}</span>
                          @if (item.establishment) {
                            <span class="text-xs opacity-70">{{
                              item.establishment.name
                            }}</span>
                          }
                        </div>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.name }}
                        @if (item.establishment) {
                          <span class="opacity-70"
                            >({{ item.establishment.name }})</span
                          >
                        }
                      </ng-template>
                    </ng-select>
                    <form-error
                      [control]="form.get('pointOfSalesId')"
                    ></form-error>
                  } @else {
                    <loading-or-error
                      (retry)="initSalePointsListener()"
                      [error$]="STATE.salePointsLoadingError"
                      spinnerSize="sm"
                    ></loading-or-error>
                  }
                </div>
                <div>
                  <label
                    for="issuedAt"
                    requiredAsterisk="issuedAt"
                    class="form__label"
                    >Date de facture</label
                  >
                  <mat-form-field>
                    <input
                      (click)="issueDatePicker.open()"
                      matInput
                      [matDatepicker]="issueDatePicker"
                      id="issuedAt"
                      formControlName="issuedAt"
                      placeholder="JJ/MM/AAAA"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="issueDatePicker"
                    >
                      <mat-icon
                        matDatepickerToggleIcon
                        svgIcon="dgi-calendar-02"
                      ></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #issueDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div>
                  <label for="dueDate" class="form__label"
                    >Date d'échéance</label
                  >
                  <mat-form-field>
                    <input
                      (click)="certificatedDatePicker.open()"
                      matInput
                      [matDatepicker]="certificatedDatePicker"
                      id="dueDate"
                      formControlName="dueDate"
                      placeholder="JJ/MM/AAAA"
                      [min]="form.get('issuedAt')?.value"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="certificatedDatePicker"
                    >
                      <mat-icon
                        matDatepickerToggleIcon
                        svgIcon="dgi-calendar-02"
                      ></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #certificatedDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </article>
            </section>
          </form>
        </section>

        <section class="form-container">
          <div class="form-container__group">
            <hgroup>Informations de client</hgroup>
            <article>
              <section>
                <div>
                  <label for="searchControl" class="form__label">
                    {{ searchControlTitle }}
                    <span class="form__label--required">*</span>
                  </label>
                  <mat-form-field>
                    <input
                      type="text"
                      id="searchControl"
                      matInput
                      [formControl]="searchControl"
                      [matAutocomplete]="auto"
                      (blur)="onBlur()"
                      [placeholder]="searchControlPlaceholder"
                    />
                    <mat-autocomplete
                      [autoActiveFirstOption]="false"
                      #auto="matAutocomplete"
                      (optionSelected)="onPartnerSelected($event.option.value)"
                    >
                      @for (option of partners(); track option.id) {
                        <mat-option [value]="option">
                          <div class="mat-option__title">
                            {{ option.name }}
                          </div>
                          @if ($any(option).nif || $any(option).ncc) {
                            <div class="mat-option__subtitle">
                              NCC:
                              <span>{{
                                $any(option).nif || $any(option).ncc
                              }}</span>
                            </div>
                          }
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                @if (showWarningMessage) {
                  <div class="warning-message">
                    L’entreprise a été retrouvée, mais aucune adresse de
                    facturation n’a encore été renseignée. Merci de compléter
                    les informations d’adresse afin de pouvoir poursuivre vers
                    la facturation.
                  </div>
                }
                @if (
                  $any(STATE.selectedPartner) &&
                  $any(STATE.selectedPartner)?.type === billingType.bToF
                ) {
                  <article class="form-grid--cols">
                    <div>
                      <label for="Partnercurrency" class="form__label">
                        Devise de facturation
                      </label>
                      <input
                        id="Partnercurrency"
                        type="text"
                        class="form__input"
                        [value]="$any(STATE.selectedPartner)?.billingCurrency"
                        [disabled]="true"
                      />
                    </div>
                    <div [formGroup]="form" class="form__group">
                      <label
                        for="conversionRate"
                        requiredAsterisk="conversionRate"
                        class="form__label"
                        >Taux de conversion
                      </label>
                      <input
                        id="conversionRate"
                        formControlName="conversionRate"
                        mask="separator.7"
                        thousandSeparator=" "
                        [outputTransformFn]="parseNumberFn"
                        class="form__input"
                        placeholder="Saisir le taux"
                      />
                    </div>
                  </article>
                }

                @if (
                  ($any(STATE.selectedPartner) &&
                    !$any(STATE.selectedPartner)?.name) ||
                  ($any(STATE.selectedPartner)?.ncc &&
                    billingTypeValue === billingType.bToB)
                ) {
                  <article>
                    <form [formGroup]="partnerForm">
                      <div
                        [class]="
                          billingTypeValue === billingType.bToF
                            ? 'form-grid--cols'
                            : 'form-grid--rows'
                        "
                      >
                        <div>
                          <label
                            for="partnerPhoneNumber"
                            requiredAsterisk="phoneNumber"
                            class="form__label"
                            >Téléphone</label
                          >
                          <input
                            #partnerInputPhone
                            (keypress)="validatePhoneNumberFn($event)"
                            id="partnerPhoneNumber"
                            type="tel"
                            class="form__input"
                            formControlName="phoneNumber"
                            validatePhoneNumberFn="validatePhoneNumber"
                            placeholder="Numéro de téléphone"
                          />
                          <form-error
                            [control]="partnerForm.get('phoneNumber')"
                          ></form-error>
                        </div>

                        @if (billingTypeValue === billingType.bToF) {
                          <div>
                            <label
                              for="billingCurrency"
                              requiredAsterisk="billingCurrency"
                              class="form__label"
                            >
                              Devise de facturation
                            </label>
                            <ng-select
                              [items]="billingCurrencies"
                              bindLabel="label"
                              bindValue="value"
                              labelForId="billingCurrency"
                              appendTo="body"
                              formControlName="billingCurrency"
                              clearAllText="Effacer"
                              [clearable]="false"
                              placeholder="Sélectionner la dévise"
                            >
                              <ng-template ng-option-tmp let-item="item">
                                {{ item | currency }}
                              </ng-template>
                              <ng-template ng-label-tmp let-item="item">
                                {{ item | currency }}
                              </ng-template>
                            </ng-select>
                            <form-error
                              [control]="form.get('billingCurrency')"
                            ></form-error>
                          </div>
                        }
                      </div>
                    </form>
                  </article>
                }

                @if (
                  $any(STATE.selectedPartner) &&
                  !$any(STATE.selectedPartner)?.name &&
                  billingTypeValue === billingType.bToF
                ) {
                  <article [formGroup]="form">
                    <div class="form__group">
                      <label
                        for="conversionRate"
                        requiredAsterisk="conversionRate"
                        class="form__label"
                        >Taux de conversion
                        {{
                          '(' +
                            (partnerForm.get('billingCurrency')?.value || '') +
                            (form.get('billingCurrency')?.value || '') +
                            ')'
                        }}
                      </label>
                      <input
                        id="conversionRate"
                        formControlName="conversionRate"
                        mask="separator.7"
                        thousandSeparator=" "
                        [outputTransformFn]="parseNumberFn"
                        class="form__input"
                        placeholder="Saisir le taux"
                      />
                    </div>
                  </article>
                }
              </section>
            </article>
          </div>
        </section>

        <section class="form-container">
          <article class="form-container__group">
            <hgroup>Adresse de facturation</hgroup>
            @if ($any(STATE.selectedPartner)) {
              @if (hasBillingAddress) {
                @for (
                  billingAddress of $any(STATE.selectedPartner)
                    ?.billingAddresses;
                  track i;
                  let i = $index
                ) {
                  <billing-address
                    [billingAddress]="billingAddress"
                    [nif]="$any(STATE.selectedPartner)?.nif"
                    [idu]="$any(STATE.selectedPartner)?.idu"
                    [active]="selectedIndex() === i"
                    (click)="selectAddress(i, billingAddress)"
                  ></billing-address>
                }
              }
              @if (!hasBillingAddress) {
                <form [formGroup]="billingAddressForm">
                  <div class="mb-3">
                    <label
                      for="name"
                      requiredAsterisk="name"
                      class="form__label"
                      >Intitulé</label
                    >
                    <input
                      id="name"
                      type="text"
                      class="form__input"
                      formControlName="name"
                      placeholder="Saisir le nom"
                    />
                    <form-error
                      [control]="billingAddressForm.get('name')"
                    ></form-error>
                  </div>
                  <article class="form-grid--cols">
                    @if (billingTypeValue !== billingType.bToB) {
                      <div formGroupName="address">
                        <label for="country" class="form__label">
                          Pays
                          <span class="form__label--required">*</span>
                        </label>
                        <ng-select
                          [items]="$any(STATE.countries)"
                          bindLabel="name"
                          bindValue="code"
                          appendTo="body"
                          formControlName="country"
                          placeholder="Veuillez sélectionner le pays"
                        >
                          <ng-template ng-option-tmp let-item="item">
                            {{ getFlagEmojiFn(item.code) + ' ' + item.name }}
                          </ng-template>
                          <ng-template ng-label-tmp let-item="item">
                            {{ getFlagEmojiFn(item.code) + ' ' + item.name }}
                          </ng-template>
                        </ng-select>
                        <form-error
                          [control]="billingAddressForm.get('address.country')"
                        ></form-error>
                      </div>
                    } @else {
                      <div>
                        <label for="email" class="form__label"
                          >Adresse Email</label
                        >
                        <input
                          id="email"
                          type="email"
                          class="form__input"
                          formControlName="email"
                          placeholder="Adresse électronique"
                        />
                        <form-error
                          [control]="billingAddressForm.get('email')"
                        ></form-error>
                      </div>
                    }
                    @if (billingTypeValue === billingType.bToB) {
                      <div formGroupName="address">
                        @if (STATE.cities) {
                          <label
                            for="city"
                            requiredAsterisk="address.city"
                            class="form__label"
                          >
                            Ville
                          </label>
                          <ng-select
                            [items]="$any(STATE.cities)"
                            bindLabel="label"
                            bindValue="value"
                            formControlName="city"
                            [placeholder]="
                              billingTypeValue === billingType.bToB
                                ? 'Veuillez sélectionner la ville'
                                : 'Veuillez saisir votre ville'
                            "
                            addTagText="Ajouter"
                            [addTag]="
                              billingTypeValue !== billingType.bToB
                                ? addTagFn
                                : false
                            "
                            (change)="initDistrictsListener($event?.value)"
                          ></ng-select>
                          <form-error
                            [control]="billingAddressForm.get('address.city')"
                          ></form-error>
                        } @else {
                          <loading-or-error
                            (retry)="initCitiesListener()"
                            [error$]="STATE.citiesLoadingError"
                            spinnerSize="sm"
                          ></loading-or-error>
                        }
                      </div>
                      <div formGroupName="address">
                        @if (STATE.districts) {
                          <label
                            for="district"
                            requiredAsterisk="address.district"
                            class="form__label"
                          >
                            Commune
                          </label>
                          <ng-select
                            [items]="$any(STATE.districts)"
                            bindLabel="label"
                            bindValue="value"
                            formControlName="district"
                            [placeholder]="
                              billingTypeValue === billingType.bToB
                                ? 'Veuillez sélectionner la commune'
                                : 'Veuillez saisir votre commune'
                            "
                            addTagText="Ajouter"
                            [addTag]="
                              billingTypeValue !== billingType.bToB
                                ? addTagFn
                                : false
                            "
                          ></ng-select>
                          <form-error
                            [control]="
                              billingAddressForm.get('address.district')
                            "
                          ></form-error>
                        } @else {
                          <loading-or-error
                            (retry)="initDistrictsListener()"
                            [error$]="STATE.districtsLoadingError"
                            spinnerSize="sm"
                          ></loading-or-error>
                        }
                      </div>
                    } @else {
                      <div formGroupName="address">
                        <label
                          for="city"
                          requiredAsterisk="address.city"
                          class="form__label"
                        >
                          Ville
                        </label>
                        <input
                          class="form__input"
                          formControlName="city"
                          placeholder="Veuillez saisir la ville"
                          type="text"
                          id="city"
                        />
                        <form-error
                          [control]="billingAddressForm.get('address.city')"
                        ></form-error>
                      </div>
                      <div formGroupName="address">
                        <label
                          for="district"
                          requiredAsterisk="address.district"
                          class="form__label"
                        >
                          Commune
                        </label>
                        <input
                          class="form__input"
                          formControlName="district"
                          placeholder="Veuillez saisir la commune"
                          type="text"
                          id="district"
                        />
                        <form-error
                          [control]="billingAddressForm.get('address.district')"
                        ></form-error>
                      </div>
                    }

                    <div formGroupName="address">
                      <label
                        for="location"
                        requiredAsterisk="address.location"
                        class="form__label"
                        >Adresse</label
                      >
                      <input
                        id="location"
                        type="text"
                        class="form__input"
                        formControlName="location"
                        placeholder="Rue, numéro"
                      />
                      <form-error
                        [control]="billingAddressForm.get('address.location')"
                      ></form-error>
                    </div>
                  </article>

                  <article
                    [class]="
                      billingTypeValue === billingType.bToB
                        ? 'form-grid--rows'
                        : 'form-grid--cols'
                    "
                  >
                    <div>
                      <label for="phoneNumber" class="form__label"
                        >Téléphone
                        <span class="form__label--required">*</span>
                      </label>
                      <input
                        #billingPhoneNumberInput
                        (keypress)="validatePhoneNumberFn($event)"
                        id="phoneNumber"
                        type="tel"
                        class="form__input"
                        formControlName="phoneNumber"
                        validatePhoneNumberFn="validatePhoneNumber"
                        placeholder="Numéro de téléphone"
                      />
                      <form-error
                        [control]="billingAddressForm.get('phoneNumber')"
                      ></form-error>
                    </div>
                    @if (billingTypeValue !== billingType.bToB) {
                      <div>
                        <label for="email" class="form__label"
                          >Adresse Email</label
                        >
                        <input
                          id="email"
                          type="email"
                          class="form__input"
                          formControlName="email"
                          placeholder="Adresse électronique"
                        />
                        <form-error
                          [control]="billingAddressForm.get('email')"
                        ></form-error>
                      </div>
                    }
                  </article>
                </form>
              }
            } @else {
              <span></span>
            }
          </article>
        </section>
      </ng-container>

      <ng-container footer>
        <div class="modal-footer">
          <button
            button
            type="submit"
            class="float-right"
            variant="primaryLight"
            (click)="onSubmit()"
            [loading]="STATE.isSubmitting"
            [disabled]="isSubmitDisabled || STATE.isSubmitting"
            [loadingText]="'Initialisation en cours...'"
          >
            Initialiser la facture
          </button>
        </div>
      </ng-container>
    </custom-modal-card>
  </main>
}
